angular.module('autoremind.httpInterceptor', [])
    .constant('RESOURCES', (function () {
    var API = {
        '/servlets/todo/settings/': 'mock/mock.json'
    };
    return {
        mockMod: true,
        API: {
            '/servlets/todo/settings/': '/mock/mock.options.new.options/',
            '/servlets/todo/2016-03-01/': '/mock/tasks/2016-03-01/',
            '/servlets/todo/2016-03-02/': '/mock/tasks/2016-03-02/',
            '/servlets/todo/2016-03-03/': '/mock/tasks/2016-03-03/',
            '/servlets/todo/2016-03-04/': '/mock/tasks/2016-03-04/',
            '/servlets/todo/2016-03-05/': '/mock/tasks/2016-03-05/',
            '/servlets/accounts/dashboard/': '/mock/widgets/widgets/'
        }
    };
})())
    .factory('transformResponse', ['$window', '$injector', 'RESOURCES', '$q', function ($window, $injector, RESOURCES, $q) {
        return {
            'responseError': function (err) {
                var deferred = $q.defer();
                if (!RESOURCES.mockMod || !RESOURCES.API.hasOwnProperty(err.config.url)) {
                    return $q.reject(err);
                }
                else {
                    err.config.url = RESOURCES.API[err.config.url];
                    var http = $injector.get('$http');
                    var x = http(err.config);
                    x.then(function (res) {
                        deferred.resolve(res);
                    }, function (error) {
                        delete RESOURCES.API[err.config.url];
                        deferred.reject(err);
                    });
                }
                return deferred.promise;
            }
        };
    }])
    .config(['$httpProvider', function ($httpProvider) {
        $httpProvider.interceptors.push('transformResponse');
    }]);
//# sourceMappingURL=http-data-provider.js.map